import React from 'react';
import { UserManagementIcon } from '../../assets/icons';
import RoleCreatePage from '../RoleManagement/RoleCreatePage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './AgentCreatePage.module.css';

const AgentCreatePage: React.FC = () => (
  <RoleCreatePage config={ROLE_CONFIGS.agent} styles={styles} Icon={UserManagementIcon} />
);

export default AgentCreatePage;
